export default __webpack_public_path__ + "static/media/char-k2so.d3b04457.jpg";